"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardSettingsDialogContent = exports.CardSettingsDialog = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const event_callback_hook_1 = require("../../../../utils/event-callback-hook");
const dialog_1 = require("../../../../components/dialog/dialog");
const reporting_context_1 = require("../../../reporting/reporting-context");
const report_settings_form_1 = require("../../../reporting/components/report-settings-form");
exports.CardSettingsDialog = react_1.forwardRef(
// eslint-disable-next-line no-empty-pattern
function CardSettingsDialog({ report, definition, load }, ref) {
    const intl = react_intl_1.useIntl();
    const { generate } = react_1.useContext(reporting_context_1.ReportingContext);
    const formRef = react_1.useRef(null);
    const onConfirm = event_callback_hook_1.useEventCallback(async () => {
        var _a;
        await generate(definition.id, (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.getFieldValues());
        await load();
    });
    const onShown = event_callback_hook_1.useEventCallback(() => {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.setFieldValues(report.configuration);
    });
    return (react_1.default.createElement(dialog_1.Dialog, { ref: ref, title: intl.formatMessage({
            id: 'EAS_DASHBOARD_CARD_SETTINGS_DIALOG_TITLE',
            defaultMessage: 'Nastavení prvku',
        }), onConfirm: onConfirm, onShown: onShown }, () => (react_1.default.createElement(Box_1.default, { width: 800 },
        react_1.default.createElement(CardSettingsDialogContent, { formRef: formRef, definition: definition })))));
});
function CardSettingsDialogContent({ definition, formRef, }) {
    return react_1.default.createElement(report_settings_form_1.ReportSettingsForm, { ref: formRef, definition: definition });
}
exports.CardSettingsDialogContent = CardSettingsDialogContent;
//# sourceMappingURL=card-settings-dialog.js.map